export enum CollectionLockType {
	Unlocked = 0,
	Selflock = 1,
	Locked = 2,
	Locking = 3
}